import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {BrandService} from "../../../services/brand.service";
import {first} from "rxjs/operators";
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';
import {ResourceService} from "../../../services/resource.service";

@Component({
  selector: 'app-brand-add-edit',
  templateUrl: './brand-add-edit.component.html',
  styleUrls: ['./brand-add-edit.component.scss']
})
export class BrandAddEditComponent implements OnInit {

    form: FormGroup;
    submitted = false;
    loading = false;
    id: number;
    update = false;
    pathFile = 'Elegir Foto';
    brand: any = {};

    constructor(
        private formBuilder: FormBuilder,
        private toastrService: ToastrService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private brandService: BrandService,
        private spinner: NgxSpinnerService,
        private resourceService: ResourceService,
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            photo: [''],
            type_products: '',
        });

        this.id = this.activatedRoute.snapshot.params['id'];

        if (this.id) {
            this.update = true;
            this.brandService.getById(this.id).subscribe(response => {
                this.form.patchValue(response.data);
                this.brand = response.data;
            }, error => {
                this.router.navigate(['/brands']);
            });
        }
    }

    onSelectFile(fileInput: any) {
        let photoFile = <File>fileInput.target.files[0];
        if (photoFile) {
            const formData = new FormData();
            formData.append('photo', photoFile);
            formData.append('path', 'brands');
            this.spinner.show();
            this.resourceService.uploadPhoto(formData).pipe(first()).subscribe(response => {
                this.f.photo.setValue(response.file);
                this.pathFile = photoFile.name;
                this.spinner.hide();
            }, error => {
                this.toastrService.error(error, 'Error');
                this.spinner.hide();
            });
        }
    }

    get f() {
        return this.form.controls;
    }

    sendForm() {
        this.submitted = true;
        if (!this.form.valid) {
            return;
        }
        let item = Object.assign({}, this.form.value);

        if (this.update) {
            item.id = this.id;
            this.brandService.update(item)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/brands']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        } else {
            this.brandService.store(item)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/brands']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        }
    }

}
